export const SERVICE_URL = (process.env.REACT_APP_API_URL || "http://localhost:8080").replace(/\/$/, "");
export const JSON_HEADERS = { headers: { "Content-Type": "application/json" } };